module.exports = __webpack_public_path__ + "static/media/thumbnail.969763b2.jpg";